<div class="control-container" *ngIf="checkoutStatus == paymentStatusEnum.pending; else status">
    <div class="div-container">
        <div class="page-title">Zahlung in Gange<br><br></div>
        <i class="fa-solid fa-cart-shopping"></i>
        <p>Bitte folgen Sie den Anweisungen auf dem Terminal</p>
        <!-- <button [routerLink]="['/basket']">Abbrechen</button> -->
    </div>
    <div class="background"></div>
</div>
<ng-template #status>
    <div class="control-container">
        <div class="div-container">
            <div class="page-title">{{checkoutStatus == paymentStatusEnum.captured ? 'Zahlung erfolgreich' : checkoutStatus == paymentStatusEnum.failed ? 'Zahlung
                fehlgeschlagen' : 'Unbekannter Fehler'}}<br><br></div>
            <i class="fa-solid fa-circle-check" *ngIf="checkoutStatus == paymentStatusEnum.captured"></i>
            <i class="fa-solid fa-circle-exclamation" *ngIf="checkoutStatus == paymentStatusEnum.failed"></i>
            <i class="fa-solid fa-circle-question" *ngIf="checkoutStatus == paymentStatusEnum.unknown"></i>
            <p>{{checkoutStatus == paymentStatusEnum.captured ? 'Die Zahlung wurde erfolgreich abgeschlossen. Vielen
                Dank für Ihren Einkauf.' : "Etwas ist schief gelaufen. Bitte versuchen Sie es erneut."}}</p>
            <div class="buttons" *ngIf="checkoutStatus == paymentStatusEnum.failed || checkoutStatus == paymentStatusEnum.unknown">
                <button [routerLink]="['/basket']">Abbrechen</button>
                <button (click)="retry()">Wiederholen</button>
            </div>
            <div class="buttons" *ngIf="checkoutStatus == paymentStatusEnum.captured">
                <button [routerLink]="['/home']">Keine Quittung</button>
                <button [ngStyle]="{'opacity': printing ? '0.5' : '1'}" (click)="printReceipt()">
                    Quittung drucken
                </button>
            </div>
        </div>
        <div class="background" [ngClass]="checkoutStatus == paymentStatusEnum.captured ? 'success' : 'failure'"></div>
    </div>
</ng-template>
<div help-triangle></div>